import React, { useEffect } from 'react';
import { Input, IconBtn } from "components/shared"
import { FlapHeader } from "components/layout/";
import { ActivityKapis, AgentActivityHoc, RecapKpisHoc, QualityKpis, DimensionsFilterHoc } from 'components/pages';
import { useHistory } from 'react-router';
import Utils, { BASE_ROUTES, ANALYTICS_PANEL_ITEMS } from 'utils';
import "components/pages/analytics-page/dashboard/style.scss";
import $ from "jquery";
import utils from 'utils';

export const Dashboard = () => {

    const history = useHistory();
    const filterSearchParam = new URLSearchParams(history.location.search).get("filter") ? JSON.parse(new URLSearchParams(history.location.search).get("filter")) : {}
    const displayDimensFilter = history.location.pathname !== `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.AGENT_ACTIVITY}`;

    useEffect(() => {
        //INITIALIZE FILTER RANGE DATES WITHIN URL SEARCH PARAM
        const initFilterDates = () => {
            if (!filterSearchParam["startDate"]) {
                filterSearchParam["startDate"] = utils.getRangeDatesOfLastMonth().startDate;
                Utils.pushURLSearchParams(history, "filter", JSON.stringify(filterSearchParam));
            }
            if (!filterSearchParam["endDate"]) {
                filterSearchParam["endDate"] = utils.getRangeDatesOfLastMonth().endDate;
                Utils.pushURLSearchParams(history, "filter", JSON.stringify(filterSearchParam));
            }
        }
        initFilterDates();
    }, []);

    //ON FILTER DATE CHANGE EVENT
    const onFilterDateChange = (e, field) => {
        filterSearchParam[field] = e.target.value;
        Utils.pushURLSearchParams(history, "filter", JSON.stringify(filterSearchParam));
    }

    //ANTICIPATE COMPONENT RENDERING
    const TargetComponent = () => {
        switch (history.location.pathname) {
            case `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.FLUX_ACTIVITY}`: {
                return <ActivityKapis />
            }
            case `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.AGENT_ACTIVITY}`: {
                //return <GlobalPerformanceKpis />;
                return <AgentActivityHoc />
            }
            case `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.QUALITY}`: {
                return <QualityKpis />;
            }
            default: {
                return <ActivityKapis />
            }
        }
    }

    return (
        <>
            <FlapHeader
                primeary
                justify
                className="mx-0"
                leftSide={<span className="pt-1">Dashboard</span>}
                rightSide={
                    <aside className="d-flex">
                        <FilterInputDate
                            label="From"
                            value={filterSearchParam.startDate ? filterSearchParam.startDate : utils.getRangeDatesOfLastMonth().startDate}
                            onChange={(e) => onFilterDateChange(e, "startDate")}
                        />
                        <FilterInputDate
                            label="To"
                            value={filterSearchParam.endDate ? filterSearchParam.endDate : utils.getRangeDatesOfLastMonth().endDate}
                            onChange={(e) => onFilterDateChange(e, "endDate")} />

                        <ClearFilterSearchParam
                            display={new URLSearchParams(history.location.search).get("filter")}
                            callbackClick={() => {
                                history.push(history.location.pathname);
                                $("input[type=date]").val(null)
                            }}
                        />

                    </aside>}
            />

            <div className="scroll-container" style={{ height: "80vh" }}>                
                <RecapKpisHoc />
                {
                    displayDimensFilter &&
                    <DimensionsFilterHoc />
                }
                <TargetComponent />
            </div>
        </>
    );
}


export const FilterInputDate = (props) => {
    const { id, label, value, onChange } = props;

    return (
        <div className="d-flex">
            <small className="m-2">{label}</small>
            <Input id={id} type="date" height="32px" value={value} onChange={onChange} />
            {/* <Input type="time" height="32px" value={value} onChange={onChange} /> */}
        </div>
    );
}

const ClearFilterSearchParam = (props) => {
    const { display, callbackClick } = props;
    return (
        <>
            {display && <IconBtn className="bi bi-x-circle mx-2 my-1" onClick={() => { callbackClick(); }} />}
        </>
    )
}